import { render, staticRenderFns } from "./GraphicsController.vue?vue&type=template&id=5881c37e"
import script from "./GraphicsController.vue?vue&type=script&lang=ts"
export * from "./GraphicsController.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports